import axios from "@/axios";

const getDefaultState = () => ({
    historicoAnalises: {},
    analiseSelecionada: {}
});

const state = getDefaultState();

const mutations = {
    SET_HISTORICO_ANALISES(state, historico) {
        state.historicoAnalises = historico;
    },
    SET_ANALISE_SELECIONADA(state, analise) {
        state.analiseSelecionada = analise;
    },
    reset(state) {
        Object.assign(state, getDefaultState());
    }
};

const actions = {
    async processarAnaliseIa({ commit }, body) { 
        try {
            const response = await axios.post(`/ia`, body);
            if (response.data.error) {
                commit('SET_ANALISE_SELECIONADA', {});
                return { 
                    error: true, 
                    message: response.data.message 
                };
            }
            const res = response.data.response;
            if (res && res.message && !res.data) {
                commit('SET_ANALISE_SELECIONADA', {});
                return { error: true, message: res.message };
            }
            return res.data.payload.data; 
        } catch (error) { 
            console.error("Erro ao processar análise IA:", error); 
            throw error; 
        } 
    },

    async getHistoricoAnalises({ commit }, unidadeId) {
        try {
            const response = await axios.get(`/ia/analises/silos/${unidadeId}`);

            const data = response.data.response;
            commit('SET_HISTORICO_ANALISES', data);

            return data;
        } catch (error) {
            console.error("Erro ao buscar histórico de análises:", error);
            throw error;
        }
    },

    async getAnaliseById({ commit }, analiseId) {
        try {
            const response = await axios.get(`/ia/analises/${analiseId}`);
            const data = response.data.response;

            if (data.status == 2) {
                commit('SET_ANALISE_SELECIONADA', data);
            }

            return data.status;
        } catch (error) {
            console.error("Erro ao buscar análise por ID:", error);
            throw error;
        }
    },

    async getResumoSilos(_, unidadeId) {
        try {
            const response = await axios.get(`/ia/unidades/${unidadeId}/silos`);
            return response.data.response || [];
        } catch (error) {
            console.error("Erro ao buscar resumo dos silos:", error);
            return [];
        }
    },

    async getUltimaUg(_, siloId) {
        try {
            const response = await axios.get(`/ia/silos/${siloId}/ultima-ug`);
            return response.data.response;
        } catch (error) {
            console.error("Erro ao buscar última umidade do grão:", error);
            return null;
        }
    },

    async deleteAnaliseById({ commit }, analiseId) {
        try {
            const response = await axios.delete(`/ia/analises/${analiseId}`);
            commit('SET_ANALISE_SELECIONADA', {});
            return response.data;
        } catch (error) {
            console.error("Erro ao excluir análise por ID:", error);
            throw error;
        }
    }
};

export default {
    namespaced: true,
    state,
    actions,
    mutations
};